import { ReactNode, RefObject, useEffect, useRef, useState } from "react";
import { ParagraphWrapper } from "./atom";
import { ToolTip } from "../tooltip";
import { Space } from "../space";
import ClearIcon from "../../assets/svg/clear-icon";
import { PlacementType } from "../../constants";

export function Paragraph({
  ellipsis = true,
  ellipsisLength = 8,
  tooltip = true,
  tooltipText = "",
  text = "",
  tooltipMaxWidth = "",
  maxWidth = "max-content",
  clearable = false,
  placeholder,
  fitParent,
  placement = "top",
  onClear = () => {},
}: ParagraphProps) {
  const contentRef = useRef(null);
  const [hasEllipsis, setHasEllipsis] = useState(false);
  useEffect(() => {
    if (contentRef.current) {
      const maxWidthNum = maxWidth.includes("px") ? maxWidth.split("px")[0] : 0;
      if (!maxWidthNum) return;
      setHasEllipsis(+contentRef.current.offsetWidth >= +maxWidthNum);
    }
  }, [contentRef, clearable, text, maxWidth]);

  const renderContent = () => {
    const content =
      clearable && text ? (
        <>
          <span>{text !== "" ? text : placeholder}</span>
          <ClearIcon className="clear-icon" onClick={onClear} />
        </>
      ) : (
        <span>{text !== "" ? text : placeholder}</span>
      );
    return (
      <ParagraphWrapper
        className="task-eva-paragraph"
        width={maxWidth}
        ellipsis={hasEllipsis}
        ref={contentRef}
        clearable={clearable}
        fitParent={fitParent}
        isPlaceholder={Boolean(!text && placeholder)}
      >
        {content}
      </ParagraphWrapper>
    );
  };
  return tooltip && hasEllipsis ? (
    <ToolTip
      content={text}
      maxWidth={tooltipMaxWidth || maxWidth}
      hidden={!text}
      placement={placement}
      style={{
        height: fitParent && "100%",
      }}
    >
      {renderContent()}
    </ToolTip>
  ) : (
    renderContent()
  );
}

export type ParagraphProps = {
  ellipsis?: boolean;
  ellipsisLength?: number;
  tooltip?: boolean;
  tooltipText?: string | number | React.ReactNode;
  tooltipMaxWidth?: string;
  text?: ReactNode;
  maxWidth: string;
  clearable?: boolean;
  placeholder?: ReactNode;
  fitParent?: boolean;
  placement?: PlacementType;
  onClear?: (e: React.MouseEvent<SVGAElement>) => void;
};
